import { writable } from 'svelte/store'
import { analytics } from '$lib/utilities/AnalyticsTools'

/**
 * Custom alerts store creator
 */
export const createAlerts = () => {
    const { subscribe, update, set } = writable([])

    return {
        subscribe,
        add: (severity, message) => {
            update(state => [...state, { severity, message }])
            analytics.track('display_alert', { severity, message })
        },
        clear: i => update(state => state.filter((_, index) => index !== i)),
        clearAll: () => set([]),
    }
}
